/**
 * Links into the Mini App: https://t.me/<bot>?startapp=<param>.
 * Telegram hands the `startapp` value back as `start_param` in initData (the backend reads the
 * inviter's Telegram id from its leading digits — see UserServiceImpl.processReferral).
 */
export const BOT_USERNAME = process.env.REACT_APP_BOT_USERNAME || 'Dev_DatumCore_bot';

export function startAppLink(param) {
  return `https://t.me/${BOT_USERNAME}?startapp=${encodeURIComponent(param)}`;
}

/** start_param this Mini App was launched with ('' when none). */
export function getLaunchStartParam() {
  const tg = typeof window !== 'undefined' ? window.Telegram?.WebApp : null;
  const fromInit = tg?.initDataUnsafe?.start_param;
  if (fromInit) return String(fromInit);
  try {
    // outside of the Telegram client the param is in the URL (tgWebAppStartParam=…)
    return new URLSearchParams(window.location.search).get('tgWebAppStartParam') || '';
  } catch (e) {
    return '';
  }
}

/** Clipboard with a fallback for WebViews without navigator.clipboard. Resolves to true on success. */
export async function copyText(text) {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (e) { /* fall through */ }
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch (e) {
    return false;
  }
}

/** Telegram share sheet (pick a chat); Web Share API / clipboard outside of Telegram. */
export async function shareLink(link, text = '') {
  const tg = typeof window !== 'undefined' ? window.Telegram?.WebApp : null;
  const url = `https://t.me/share/url?url=${encodeURIComponent(link)}${text ? `&text=${encodeURIComponent(text)}` : ''}`;
  if (tg?.openTelegramLink) {
    tg.openTelegramLink(url);
    return 'telegram';
  }
  if (navigator.share) {
    try {
      await navigator.share({ text, url: link });
      return 'native';
    } catch (e) { /* cancelled → copy */ }
  }
  return (await copyText(link)) ? 'copied' : 'failed';
}
